import { motion } from "framer-motion";
import React, { forwardRef } from "react";
import { getIconCategory } from "../../utils/utils";

const Category = forwardRef(({ name, icon, isSelected, onClick }, ref) => {
    const Icon = getIconCategory(icon);
    return (
        <button
            ref={ref}
            onClick={onClick}
            className="flex flex-col items-center justify-center min-w-[80px] focus:outline-none"
        >
            <motion.div
                animate={isSelected ? { scale: 1.15 } : { scale: 1 }}
                transition={{ type: "spring", stiffness: 300, damping: 15 }}
                className={`w-16 h-16 flex items-center justify-center rounded-full border-2 border ${isSelected ? "border-primary" : "border-transparent"
                    } bg-surface shadow-md`}
            >
                {React.cloneElement(Icon, { className: `w-7 h-7 ${isSelected ? "text-primary" : "text-muted"}` })}
            </motion.div>
            <span
                className={`mt-2 text-sm font-medium ${isSelected ? "text-primary" : "text-muted"
                    }`}
            >
                {name}
            </span>
        </button>
    );
});

export default Category;